import React, { useEffect, useState } from "react";
import { Row, Col, Table, Space, Select, Card, Statistic, DatePicker, List, Typography, Button } from "antd";
import styled from "styled-components";
import { adjustHue, darken, lighten, linearGradient } from "polished";
import dayjs from 'dayjs'
import { Column, Pie, measureTextWidth } from "@ant-design/plots";
import axios from "axios";

const Texture = (props) => {
    switch (props) {
        case 1: {
            return '#f9ad0e';
        }
        case 2: {
            return '#d1d7da';
        }
        case 3: {
            return '#df7e08';
        }
        default: {
            return '#d1d7da'
        }

    }
}
const Medal = styled.div`

  // CSS reset END

    $gold-medal: #f9ad0e;
    $silver-medal: #d1d7da;
    $bronze-medal: #df7e08;
    $neutral-medal: #d1d7da;

    .quiz-medal {
        position: relative;
        margin-bottom: 16px;
    }
    
    .quiz-medal__circle {
        font-family: 'Roboto', sans-serif;
        font-size: 28px;
        font-weight: 500;
        width: 56px;
        height: 56px;
        border-radius: 100%;
        color: white;
        text-align: center;
        line-height: 46px;
        vertical-align: middle;
        position: relative;
        border-width: 0.2em;
        border-style: solid;
        z-index: 1;

    // Default colors
    box-shadow: inset 0 0 0 ${props => {
        const type = {
            gold: props.type === 1,
            silver: props.type === 2,
            bronze: props.type === 3,
            neutral: props.type === 4,
        }
        return darken(0.15, Texture(props.rank))
    }}, 2px 2px 0 rgba(0, 0, 0, 0.08);
    border-color: ${props => lighten(0.1, adjustHue(10, Texture(props.rank)))};
    text-shadow: 2px 2px 0 ${props => darken(0.2, Texture(props.rank))};
    background: ${props =>
        linearGradient({
            toDirection: ['to bottom right'],
            colorStops: [Texture(props.rank) + ' 50%', darken(0.05, Texture(props.rank)) + ' 50%']
        })};
    }

    .quiz-medal__ribbon {
        content: "";
        display: block;
        position: absolute;
        border-style: solid;
        border-width: 6px 10px;
        width: 0;
        height: 20px;
        top: 50px;
    }
    
    .quiz-medal__ribbon--left {
        border-color: #FC402D #FC402D transparent #FC402D;
        left: 8px;
        transform: rotate(20deg) translateZ(-32px);
    }
    
    .quiz-medal__ribbon--right {
        left: 28px;
        border-color: ${props => darken(0.1, '#FC402D')} ${props => darken(0.1, '#FC402D')} transparent ${props => darken(0.1, '#FC402D')};
        transform: rotate(-20deg) translateZ(-48px);
    }
        
`
const MetalShow = (props) => {
    if (props.index < 3) {
        return (
            <Medal rank={props.index + 1}>
                <div class="quiz-medal">
                    <div class="quiz-medal__circle quiz-medal__circle--gold">
                        <span>
                            {props.index + 1}
                        </span>
                    </div>
                    <div class="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
                    <div class="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
                </div>
            </Medal>
        )
    }
    else {
        return (<div style={{ width: '56px', height: '56px', textAlign: 'center', fontSize: '28px', fontWeight: '300' }}>{props.index + 1}</div>)
    }
    // return (
    //     <Medal rank={props.index + 1}>
    //         <div class="quiz-medal">
    //             <div class="quiz-medal__circle quiz-medal__circle--gold">
    //                 <span>
    //                     {props.index + 1}
    //                 </span>
    //             </div>
    //             <div class="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
    //             <div class="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
    //         </div>
    //     </Medal>
    // )
}
const ChartStatic = () => {
    const [data, setData] = useState([]);
    const [rwdFunctionClick, setRwdFunctionClick] = useState([])
    const [rwdFunctionDate, setRwdFunctionDate] = useState([dayjs().subtract(7, 'day'), dayjs()])
    const [dataDate, setDataDate] = useState([dayjs().subtract(7, 'day'), dayjs()])
    useEffect(() => {
        getRwdFunctionClick(rwdFunctionDate)
    }, [rwdFunctionDate]);
    useEffect(() => {
        asyncFetch(dataDate);
    }, [dataDate]);


    const asyncFetch = (dateStrings) => {
        axios.get('/system/news/statistics_click', {
            params: {
                start_date: dateStrings?.[0],
                end_date: dateStrings?.[1]
            }
        })
            .then((response) => {
                let data = response.data
                setData(data)
            })
            .catch((error) => console.log(error))

    };
    const getRwdFunctionClick = (dateStrings) => {
        axios.get('/app/rwd_function/statistics_click', {
            params: {
                start_date: dateStrings?.[0],
                end_date: dateStrings?.[1]
            }
        })
            .then((response) => {
                let data = response.data
                setRwdFunctionClick(data)
            })
            .catch((error) => console.log(error))
    }
    function renderStatistic(containerWidth, text, style) {
        const { width: textWidth, height: textHeight } = measureTextWidth(text, style);
        const R = containerWidth / 2; // r^2 = (w / 2)^2 + (h - offsetY)^2

        let scale = 1;

        if (containerWidth < textWidth) {
            scale = Math.min(Math.sqrt(Math.abs(Math.pow(R, 2) / (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)))), 1);
        }

        const textStyleStr = `width:${containerWidth}px;`;
        return `<div style="${textStyleStr};font-size:${scale}em;line-height:${scale < 1 ? 1 : 'inherit'};">${text}</div>`;
    }
    const getNewsExcel = () => {
        axios.get('/system/news/statistics_click_excel', {
            responseType: 'blob',
            params: {
                start_date: dataDate?.[0],
                end_date: dataDate?.[1]
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `最新消息點閱統計.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
    }
    const getRwdFunctionExcel = () => {
        axios.get('/app/rwd_function/statistics_click_excel', {
            responseType: 'blob',
            params: {
                start_date: rwdFunctionDate?.[0],
                end_date: rwdFunctionDate?.[1]
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `服務使用次數統計.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
    }

    // const config = {
    //     data,
    //     xField: 'date',
    //     yField: 'value',
    //     seriesField: 'country',
    //     xAxis: {
    //         tickCount: 5,
    //     },
    //     label: {},
    //     animation: false,
    //     slider: {
    //         start: 0.1,
    //         end: 0.9,
    //         trendCfg: {
    //             isArea: true,
    //         },
    //     },
    // };
    const config = {
        appendPadding: 10,
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 1,
        innerRadius: 0.64,
        meta: {
            value: {
                formatter: (v) => `${v} 人`,
            },
        },
        label: {
            type: 'inner',
            offset: '-50%',
            style: {
                textAlign: 'center',
            },
            autoRotate: false,
            content: '{value}',
        },
        statistic: {
            title: {
                offsetY: -4,
                customHtml: (container, view, datum) => {
                    const { width, height } = container.getBoundingClientRect();
                    const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
                    const text = datum ? datum.type : '';
                    return renderStatistic(d, text, {
                        fontSize: 28,
                    });
                },
            },
            content: {
                offsetY: 4,
                style: {
                    fontSize: '32px',
                },
                customHtml: (container, view, datum, data) => {
                    const { width } = container.getBoundingClientRect();
                    const text = datum ? ` ${datum.value}` : ` ${data.reduce((r, d) => r + d.value, 0)}`;
                    return renderStatistic(width, text, {
                        fontSize: 32,
                    });
                },
            },
        },
        // 添加 中心统计文本 交互
        interactions: [
            {
                type: 'element-selected',
            },
            {
                type: 'element-active',
            },
            {
                type: 'pie-statistic-active',
            },
        ],
    };
    const config2 = {
        appendPadding: 10,
        data: rwdFunctionClick,
        angleField: 'value',
        colorField: 'type',
        radius: 1,
        innerRadius: 0.64,
        meta: {
            value: {
                formatter: (v) => `${v} 人`,
            },
        },
        label: {
            type: 'inner',
            offset: '-50%',
            style: {
                textAlign: 'center',
            },
            autoRotate: false,
            content: '{value}',
        },
        statistic: {
            title: {
                offsetY: -4,
                customHtml: (container, view, datum) => {
                    const { width, height } = container.getBoundingClientRect();
                    const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
                    const text = datum ? datum.type : '';
                    return renderStatistic(d, text, {
                        fontSize: 28,
                    });
                },
            },
            content: {
                offsetY: 4,
                style: {
                    fontSize: '32px',
                },
                customHtml: (container, view, datum, data) => {
                    const { width } = container.getBoundingClientRect();
                    const text = datum ? ` ${datum.value}` : ` ${data.reduce((r, d) => r + d.value, 0)}`;
                    return renderStatistic(width, text, {
                        fontSize: 32,
                    });
                },
            },
        },
        // 添加 中心统计文本 交互
        interactions: [
            {
                type: 'element-selected',
            },
            {
                type: 'element-active',
            },
            {
                type: 'pie-statistic-active',
            },
        ],
    };
    return (<>
        <Row>
            <Col span={24}>
                <Row gutter={[20, 10]}>
                    <Col span={12}>
                        <Card>
                            <Row>
                                <Col span={24}>
                                    <Row justify={"space-between"}>
                                        <Col>
                                            <Typography.Title level={4}>
                                                最新消息點閱統計
                                            </Typography.Title>
                                        </Col>
                                        <Col>
                                            <Button
                                                type='text'
                                                style={{
                                                    color: "#fff",
                                                    backgroundColor: "#56b673"
                                                }}
                                                onClick={() => { getNewsExcel() }}
                                            >
                                                匯出檔案
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Space>
                                        <text>分析時間</text>
                                        <DatePicker.RangePicker
                                            allowClear={false}
                                            defaultValue={[dayjs().subtract(7, 'day'), dayjs()]}
                                            onCalendarChange={(dates, dateStrings) => {
                                                setDataDate(dateStrings)
                                            }}
                                        />
                                    </Space>
                                    <Pie {...config} />
                                    {/* <Area {...config} /> */}
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card>
                            <Row>
                                <Col span={24}>
                                    <Row justify={"space-between"}>
                                        <Col>
                                            <Typography.Title level={4}>
                                                服務使用次數統計
                                            </Typography.Title>
                                        </Col>
                                        <Col>
                                            <Button
                                                type='text'
                                                style={{
                                                    color: "#fff",
                                                    backgroundColor: "#56b673"
                                                }}
                                                onClick={() => { getRwdFunctionExcel() }}
                                            >
                                                匯出檔案
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Space>
                                        <text>分析時間</text>
                                        <DatePicker.RangePicker
                                            allowClear={false}
                                            defaultValue={[dayjs().subtract(7, 'day'), dayjs()]}
                                            onCalendarChange={(dates, dateStrings) => {
                                                setRwdFunctionDate(dateStrings)
                                            }}
                                        />
                                    </Space>
                                    <Pie {...config2} />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

            </Col>
        </Row>
    </>)
}
const AppStatic = () => {
    const [appleData, setAppleData] = useState([]);
    const [androidData, setAndroidData] = useState([]);
    const [rwdFunctionClick, setRwdFunctionClick] = useState([])
    const [rwdFunctionDate, setRwdFunctionDate] = useState([dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')])
    // const [dataDate, setDataDate] = useState([dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')])
    const [appleDate, setAppleDate] = useState([dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]);
    const [androidDate, setAndroidDate] = useState([dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]);
    
    useEffect(() => {
        getRwdFunctionClick(rwdFunctionDate)
    }, [rwdFunctionDate]);

    // useEffect(() => {
    //     asyncFetch(dataDate);
    // }, [dataDate]);

    useEffect(() => {
        asyncFetch(appleDate, 'apple');
    }, [appleDate]);

    useEffect(() => {
        asyncFetch(androidDate, 'android');
    }, [androidDate]);

    const asyncFetch = (dateStrings, type) => {
        axios.get('/app/download_statistics', {
            params: {
                start_time: dateStrings?.[0],
                end_time: dateStrings?.[1]
            }
        })
        .then((response) => {
            let data = response.data.data;
            if (type === 'apple') {
                let appleData = data.map(item => ({
                    type: item.type,
                    value: item.value_apple
                }));
                setAppleData(appleData);
            } else {
                let androidData = data.map(item => ({
                    type: item.type,
                    value: item.value_android
                }));
                setAndroidData(androidData);
            }
        })
        .catch((error) => console.log(error))

    };
    const getRwdFunctionClick = (dateStrings) => {
        axios.get('/system/user/token/log/statistics', {
            params: {
                start_time: dateStrings?.[0],
                end_time: dateStrings?.[1]
            }
        })
            .then((response) => {
                let data = response.data.data
                setRwdFunctionClick(data)
            })
            .catch((error) => console.log(error))
    }
    function renderStatistic(containerWidth, text, style) {
        const { width: textWidth, height: textHeight } = measureTextWidth(text, style);
        const R = containerWidth / 2; // r^2 = (w / 2)^2 + (h - offsetY)^2

        let scale = 1;

        if (containerWidth < textWidth) {
            scale = Math.min(Math.sqrt(Math.abs(Math.pow(R, 2) / (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)))), 1);
        }

        const textStyleStr = `width:${containerWidth}px;`;
        return `<div style="${textStyleStr};font-size:${scale}em;line-height:${scale < 1 ? 1 : 'inherit'};">${text}</div>`;
    }
    const getNewsExcel = (type) => {
        // console.log("type",type);
        const date = type === 'apple' ? appleDate : androidDate;
        axios.get('/app/download_statistics_excel', {
            responseType: 'blob',
            params: {
                os_type: type,
                start_time: date?.[0],
                end_time: date?.[1]
            }
        })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `App下載數(${type}).xlsx`);
            document.body.appendChild(link);
            link.click();
        });
    };

    const getRwdFunctionExcel = () => {
        axios.get('/system/user/token/log/statistics_excel', {
            responseType: 'blob',
            params: {
                start_time: rwdFunctionDate?.[0],
                end_time: rwdFunctionDate?.[1]
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `推播次數統計.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
    }

    // const config = {
    //     data,
    //     xField: 'date',
    //     yField: 'value',
    //     seriesField: 'country',
    //     xAxis: {
    //         tickCount: 5,
    //     },
    //     label: {},
    //     animation: false,
    //     slider: {
    //         start: 0.1,
    //         end: 0.9,
    //         trendCfg: {
    //             isArea: true,
    //         },
    //     },
    // };
    const commonConfig = {
        appendPadding: 10,
        radius: 1,
        innerRadius: 0.64,
        meta: {
            value: {
                formatter: (v) => `${v} 人`,
            },
        },
        label: {
            type: 'inner',
            offset: '-50%',
            style: {
                textAlign: 'center',
            },
            autoRotate: false,
            content: '{value}',
        },
        statistic: {
            title: {
                offsetY: -4,
                customHtml: (container, view, datum) => {
                    const { width, height } = container.getBoundingClientRect();
                    const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
                    const text = datum ? datum.type : '';
                    return renderStatistic(d, text, {
                        fontSize: 28,
                    });
                },
            },
            content: {
                offsetY: 4,
                style: {
                    fontSize: '32px',
                },
                customHtml: (container, view, datum, data) => {
                    const { width } = container.getBoundingClientRect();
                    const text = datum ? ` ${datum.value}` : ` ${data.reduce((r, d) => r + d.value, 0)}`;
                    return renderStatistic(width, text, {
                        fontSize: 32,
                    });
                },
            },
        },
        // 添加 中心统计文本 交互
        interactions: [
            {
                type: 'element-selected',
            },
            {
                type: 'element-active',
            },
            {
                type: 'pie-statistic-active',
            },
        ],
    };
    const config2 = {
        appendPadding: 10,
        data: rwdFunctionClick,
        angleField: 'value',
        colorField: 'type',
        radius: 1,
        innerRadius: 0.64,
        meta: {
            value: {
                formatter: (v) => `${v} 人`,
            },
        },
        label: {
            type: 'inner',
            offset: '-50%',
            style: {
                textAlign: 'center',
            },
            autoRotate: false,
            content: '{value}',
        },
        statistic: {
            title: {
                offsetY: -4,
                customHtml: (container, view, datum) => {
                    const { width, height } = container.getBoundingClientRect();
                    const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
                    const text = datum ? datum.type : '';
                    return renderStatistic(d, text, {
                        fontSize: 28,
                    });
                },
            },
            content: {
                offsetY: 4,
                style: {
                    fontSize: '32px',
                },
                customHtml: (container, view, datum, data) => {
                    const { width } = container.getBoundingClientRect();
                    const text = datum ? ` ${datum.value}` : ` ${data.reduce((r, d) => r + d.value, 0)}`;
                    return renderStatistic(width, text, {
                        fontSize: 32,
                    });
                },
            },
        },
        // 添加 中心统计文本 交互
        interactions: [
            {
                type: 'element-selected',
            },
            {
                type: 'element-active',
            },
            {
                type: 'pie-statistic-active',
            },
        ],
    };
    const appleConfig = {
        ...commonConfig,
        data: appleData,
        angleField: 'value',
        colorField: 'type',
    };

    const androidConfig = {
        ...commonConfig,
        data: androidData,
        angleField: 'value',
        colorField: 'type',
    };

    return (<>
        <Row>
            <Col span={24}>
                <Row gutter={[20, 10]}>
                    <Col span={12}>
                        <Card>
                            <Row>
                                <Col span={24}>
                                    <Row justify={"space-between"}>
                                        <Col>
                                            <Typography.Title level={4}>
                                                Apple App下載數(非即時)
                                            </Typography.Title>
                                        </Col>
                                        <Col>
                                            <Button
                                                type='text'
                                                style={{
                                                    color: "#fff",
                                                    backgroundColor: "#56b673"
                                                }}
                                                onClick={() => { getNewsExcel('apple') }}
                                            >
                                                匯出檔案
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Space>
                                        <text>分析時間</text>
                                        <DatePicker.RangePicker
                                            picker="month"
                                            allowClear={false}
                                            defaultValue={[dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')]}
                                            onCalendarChange={(dates, dateStrings) => {
                                                setAppleDate([(dates?.[0]||dayjs()).startOf('month').format("YYYY-MM-DD"), (dates?.[1]||dayjs()).endOf('month').format("YYYY-MM-DD")])
                                            }}
                                        />
                                    </Space>
                                    <Pie {...appleConfig} />
                                    {/* <Area {...config} /> */}
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card>
                            <Row>
                                <Col span={24}>
                                    <Row justify={"space-between"}>
                                        <Col>
                                            <Typography.Title level={4}>
                                                Android App下載數(非即時)
                                            </Typography.Title>
                                        </Col>
                                        <Col>
                                            <Button
                                                type='text'
                                                style={{
                                                    color: "#fff",
                                                    backgroundColor: "#56b673"
                                                }}
                                                onClick={() => { getNewsExcel('android') }}
                                            >
                                                匯出檔案
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Space>
                                        <text>分析時間</text>
                                        <DatePicker.RangePicker
                                            picker="month"
                                            allowClear={false}
                                            defaultValue={[dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')]}
                                            onCalendarChange={(dates, dateStrings) => {
                                                setAndroidDate([(dates?.[0]||dayjs()).startOf('month').format("YYYY-MM-DD"), (dates?.[1]||dayjs()).endOf('month').format("YYYY-MM-DD")])
                                            }}
                                        />
                                    </Space>
                                    <Pie {...androidConfig} />
                                    {/* <Area {...config} /> */}
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

            </Col>
        </Row>

        <Row>
            <Col span={24}>
                <Row gutter={[20, 10]}>
                    <Col span={12}>
                        <Card>
                            <Row>
                                <Col span={24}>
                                    <Row justify={"space-between"}>
                                        <Col>
                                            <Typography.Title level={4}>
                                                推播次數統計
                                            </Typography.Title>
                                        </Col>
                                        <Col>
                                            <Button
                                                type='text'
                                                style={{
                                                    color: "#fff",
                                                    backgroundColor: "#56b673"
                                                }}
                                                onClick={() => { getRwdFunctionExcel() }}
                                            >
                                                匯出檔案
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Space>
                                        <text>分析時間</text>
                                        <DatePicker.RangePicker
                                            allowClear={false}
                                            defaultValue={[dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')]}
                                            onCalendarChange={(dates, dateStrings) => {
                                                setRwdFunctionDate(dateStrings)
                                            }}
                                        />
                                    </Space>
                                    <Pie {...config2} />
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

            </Col>
        </Row>
    </>)
}
const DountConstellation = ({
    title = '',
    subTitle = '',
    type = 1
}) => {

    function renderStatistic(containerWidth, text, style) {
        const { width: textWidth, height: textHeight } = measureTextWidth(text, style);
        const R = containerWidth / 2; // r^2 = (w / 2)^2 + (h - offsetY)^2

        let scale = 1;

        if (containerWidth < textWidth) {
            scale = Math.min(Math.sqrt(Math.abs(Math.pow(R, 2) / (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)))), 1);
        }

        const textStyleStr = `width:${containerWidth}px;`;
        return `<div style="${textStyleStr};font-size:${scale}em;line-height:${scale < 1 ? 1 : 'inherit'};">${text}</div>`;
    }

    const data = type === 1 ? [
        {
            type: '獅子座',
            value: 27,
        },
        {
            type: '牡羊座',
            value: 25,
        },
        {
            type: '水瓶座',
            value: 18,
        },
        {
            type: '射手座',
            value: 15,
        },
        {
            type: '處女座',
            value: 10,
        },
        {
            type: '其他',
            value: 5,
        },
    ] :
        [
            {
                type: 'Ｏ型',
                value: 27,
            },
            {
                type: 'A型',
                value: 25,
            },
            {
                type: 'B型',
                value: 18,
            },
            {
                type: 'AB型',
                value: 15,
            },
        ];
    const config = {
        appendPadding: 10,
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 1,
        innerRadius: 0.64,
        meta: {
            value: {
                formatter: (v) => `${v} 人`,
            },
        },
        label: {
            type: 'inner',
            offset: '-50%',
            style: {
                textAlign: 'center',
            },
            autoRotate: false,
            content: '{value}',
        },
        statistic: {
            title: {
                offsetY: -4,
                customHtml: (container, view, datum) => {
                    const { width, height } = container.getBoundingClientRect();
                    const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
                    const text = datum ? datum.type : '';
                    return renderStatistic(d, text, {
                        fontSize: 28,
                    });
                },
            },
            content: {
                offsetY: 4,
                style: {
                    fontSize: '32px',
                },
                customHtml: (container, view, datum, data) => {
                    const { width } = container.getBoundingClientRect();
                    const text = datum ? ` ${datum.value}` : ` ${data.reduce((r, d) => r + d.value, 0)}`;
                    return renderStatistic(width, text, {
                        fontSize: 32,
                    });
                },
            },
        },
        // 添加 中心统计文本 交互
        interactions: [
            {
                type: 'element-selected',
            },
            {
                type: 'element-active',
            },
            {
                type: 'pie-statistic-active',
            },
        ],
    };
    return (<>
        <Typography.Title level={4} style={{ margin: 0 }}>{title}</Typography.Title>
        <Typography.Title level={4} style={{ margin: 0 }}>{subTitle}分析</Typography.Title>
        <Pie {...config} />
    </>)
}
const App = () => {


    return (
        <Row gutter={[20, 20]}>
            <Col span={24}>
                <Row gutter={[0, 20]}>
                    <Col>
                        <div style={{ backgroundColor: '#FFDAB9', width: 'fit-content', padding: '10px 15px', fontSize: '1.3em', borderRadius: '10px', boxShadow: '#e86813 1px 2px 0px' }}>
                            統計分析
                        </div>
                    </Col>
                </Row>


                {/* <Row justify={'center'} gutter={[0, 20]}>
                    <Col span={24} />
                    <Col span={20}>
                        <Tabs
                            items={items}
                        />
                    </Col>
                </Row> */}
            </Col>
            <Col span={24}>
                <Row justify={'center'} gutter={[16, 20]}>
                    <Col lg={12} md={12} sm={24} xs={24}>
                        <QAserviceChart />
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                        <BarcodeChart />
                    </Col>
                    <Col span={24}>
                        <ChartStatic />
                    </Col>
                    <Col span={24}>
                        <AppStatic />
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}
const QAserviceChart = () => {
    const [data, setData] = useState([]);
    const [checkout, setCheckout] = useState([dayjs().subtract(7, 'day'), dayjs()])
    const [fromHistory, setFromHistory] = useState("歷史借閱")
    const getData = () => {
        axios.get('/message/backend/chart/no_reply', {
            params: {
                cur_page: 1,
                size: 10000,
                start_date: checkout[0].format("YYYY-MM-DD"),
                end_date: checkout[1].format("YYYY-MM-DD"),
                // fromHistory: fromHistory === "歷史借閱" ? true : false
            }
        })
            .then((response) => {
                let data = response.data?.data || []
                let newData = data.map((value) => {
                    return {
                        ...value,
                        書名: value?.best_title,
                        借閱數: value?.checkout_count,
                    }
                })
                setData(newData)
            })
            .catch((error) => console.log(error))

    };
    const getExcel = () => {
        axios.get('/message/backend/chart/no_reply_excel', {
            responseType: 'blob',
            params: {
                cur_page: 1,
                size: 10000,
                start_date: checkout[0].format("YYYY-MM-DD"),
                end_date: checkout[1].format("YYYY-MM-DD"),
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `問答服務統計.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
    }

    const config = {
        data,
        xField: 'type',
        yField: 'value',
        label: {
            // 可手动配置 label 数据标签位置
            position: 'middle',
            // 配置样式
            style: {
                fill: '#FFFFFF',
                opacity: 0.6,
            },
        },
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
            },
        },
        meta: {
            type: {
                alias: '單位',
            },
            value: {
                alias: '使用次數',
            },
        },
        color: '#407586'
    };
    useEffect(() => {
        getData();
    }, [checkout, fromHistory]);
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row justify={"space-between"}>
                    <Col>
                        <Typography.Title level={4}>
                            問答服務統計
                        </Typography.Title>
                    </Col>
                    <Col>
                        <Button
                            type='text'
                            style={{
                                color: "#fff",
                                backgroundColor: "#56b673"
                            }}
                            onClick={() => { getExcel() }}
                        >匯出檔案</Button>
                    </Col>
                </Row>

            </Col>

            <Col span={24}>
                <Space wrap>
                    <Space>
                        <div>
                            日期：
                        </div>
                        <DatePicker.RangePicker
                            allowClear={false}
                            format={"YYYY-MM-DD"}
                            value={checkout}
                            onChange={(date, _) => {
                                setCheckout(date)
                            }}
                            presets={[
                                {
                                    label: <span >七天前</span>,
                                    value: [dayjs().subtract(7, 'day'), dayjs()],
                                },
                                {
                                    label: <span >近三個月</span>,
                                    value: [dayjs().subtract(3, 'month'), dayjs()],
                                },
                            ]}
                        />
                    </Space>
                </Space>
            </Col>
            <Col span={24}>
                <Column {...config} />
            </Col>
        </Row>)
}
const BarcodeChart = () => {
    const [data, setData] = useState([]);
    const [checkout, setCheckout] = useState([dayjs().subtract(7, 'day'), dayjs()])
    const [fromHistory, setFromHistory] = useState("歷史借閱")
    const getData = () => {
        axios.get('/message/backend/chart/barcode', {
            params: {
                cur_page: 1,
                size: 100000,
                start_date: checkout[0].format("YYYY-MM-DD"),
                end_date: checkout[1].format("YYYY-MM-DD"),
                // fromHistory: fromHistory === "歷史借閱" ? true : false
            }
        })
            .then((response) => {
                let data = response.data?.data || []
                let newData = data.map((value) => {
                    return {
                        ...value,
                        書名: value?.best_title,
                        借閱數: value?.checkout_count,
                    }
                })
                setData(newData)
            })
            .catch((error) => console.log(error))
    };
    const getExcel = () => {
        axios.get('/message/backend/chart/barcode_excel', {
            responseType: 'blob',
            params: {
                cur_page: 1,
                size: 10000,
                start_date: checkout[0].format("YYYY-MM-DD"),
                end_date: checkout[1].format("YYYY-MM-DD"),
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `行動條碼統計.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
    }
    const config = {
        data,
        xField: 'type',
        yField: 'value',
        label: {
            // 可手动配置 label 数据标签位置
            position: 'middle',
            // 配置样式
            style: {
                fill: '#FFFFFF',
                opacity: 0.6,
            },
        },
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
            },
        },
        meta: {
            type: {
                alias: '單位',
            },
            value: {
                alias: '讀取次數',
            },
        },
        color: '#f09a45'
    };
    useEffect(() => {
        getData();
    }, [checkout, fromHistory]);
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row justify={"space-between"}>
                    <Col>
                        <Typography.Title level={4}>
                            行動條碼統計
                        </Typography.Title>
                    </Col>
                    <Col>
                        <Button
                            type='text'
                            style={{
                                color: "#fff",
                                backgroundColor: "#56b673"
                            }}
                            onClick={() => { getExcel() }}
                        >匯出檔案</Button>
                    </Col>
                </Row>

            </Col>

            <Col span={24}>
                <Space wrap>
                    <Space>
                        <div>
                            日期：
                        </div>
                        <DatePicker.RangePicker
                            allowClear={false}
                            format={"YYYY-MM-DD"}
                            value={checkout}
                            onChange={(date, _) => {
                                console.log({ date, _ })
                                setCheckout(date)
                            }}
                            presets={[
                                {
                                    label: <span >七天前</span>,
                                    value: [dayjs().subtract(7, 'day'), dayjs()],
                                },
                                {
                                    label: <span >近三個月</span>,
                                    value: [dayjs().subtract(3, 'month'), dayjs()],
                                },
                            ]}
                        />
                    </Space>
                </Space>
            </Col>
            <Col span={24}>
                <Column {...config} />
            </Col>
        </Row>)
}



export default App